module.exports = __webpack_public_path__ + "static/media/mary-jane-win.fe92e0df.png";